document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".js-funding-agency-selector .funding-agency-name").forEach((fundingAgencyField) => {
    addEventListenersToAutocompleteFields(fundingAgencyField);
  });

  document.addEventListener("dynamic_list_changed", (ev) => {
    if (ev.detail.type === "add") {
      addEventListenersToAutocompleteFields(ev.detail.added.querySelector(".funding-agency-name"));
      addEventListenersToProgramAgreement(ev.detail.added.querySelector(".js-funding-agency-id"));
    }
  });

  if (document.querySelectorAll(".js-funding-agency-selector").length > 0) {
    checkIfFundingAgencySelected();
  }
});

document.querySelectorAll(".js-funding-agency-id").forEach(function (element) {
  filterProgramAgreement(element);
  addEventListenersToProgramAgreement(element);
});

function filterProgramAgreement(targetField) {
  const divCustomerFunding = targetField.closest(".js-funding");
  const programAgreementSelect = divCustomerFunding.querySelector(".js-program-agremeents-select");
  if (programAgreementSelect) {
    for (let i = 0; i < programAgreementSelect.length; i++) {
      let fundingAgencyId = programAgreementSelect[i].getAttribute("funding-agency-id");
      if (fundingAgencyId == targetField.value.toString() || fundingAgencyId == "") {
        programAgreementSelect[i].disabled = false;
      } else {
        programAgreementSelect[i].disabled = true;
      }
    }
    return;
  } else {
    return;
  }
}

function addEventListenersToAutocompleteFields(targetField) {
  targetField?.addEventListener("autocomplete", (ev) => {
    onFundingAgencyAutocomplete(ev, targetField);
  });
}

function addEventListenersToProgramAgreement(targetField) {
  targetField?.addEventListener("change", (ev) => {
    filterProgramAgreement(ev.target);
  });
}

function checkIfFundingAgencySelected() {
  const urlParams = new URLSearchParams(window.location.search);

  let funding_agency_id = urlParams.get("funding_agency_id");
  let funding_agency_name = urlParams.get("funding_agency_name");
  if (funding_agency_id != null && funding_agency_id != "") {
    document.querySelector(".js-funding-agency-selector .funding-agency-id").value = funding_agency_id;
    document.querySelector(".js-funding-agency-selector .funding-agency-name").value = funding_agency_name;
  }
}

function onFundingAgencyAutocomplete({ detail: funding_agency }, field) {
  const fundingAgencyIdField = document.getElementsByName(field.name.replace("autocomplete_", ""))[0];
  let event = new Event("change");

  if (funding_agency) {
    fundingAgencyIdField.value = funding_agency.id;
  } else {
    fundingAgencyIdField.value = "";
  }
  fundingAgencyIdField.dispatchEvent(event);
}
